var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartaxess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: " #5A6E89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-chart-no-axes-combined-icon lucide-chart-no-axes-combined",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16v5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14v7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10v11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18v3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14v7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartaxess);
export default __webpack_public_path__ + "static/media/chartaxess.e4de5c5293ca45eed2319637ad653551.svg";
export { ForwardRef as ReactComponent };